<script setup lang="ts">

import TheBottomSheet from '@/components/TheBottomSheet.vue'
import BaseButton from '@/components/base/BaseButton.vue'
import { T } from '@tolgee/vue'
import { useHapticFeedback } from '@/composables/game/haptic-feedback'
import { ref } from 'vue'

defineProps<{
  show: boolean
  friendFirstName: string
}>()

const emit = defineEmits<{
  (e: 'hide'): void
  (e: 'submit', moves: string[]): void
}>()

const { addHapticFeedback } = useHapticFeedback()

const selectedMoves = ref<string[]>([])

function addMove(move: string) {
  if (selectedMoves.value.length === 3) {
    selectedMoves.value = []
  }
  selectedMoves.value.push(move)
}

function submit() {
  if (selectedMoves.value.length < 3) {
    return
  }

  addHapticFeedback()
  emit('submit', selectedMoves.value.map(m => m[0]))
  selectedMoves.value = []
}

function hide() {
  selectedMoves.value = []
  emit('hide')
}

const moves: Record<string, string> = {
  rock: new URL(`/src/assets/stickers/general/raised-fist.gif`, import.meta.url).href,
  paper: new URL(`/src/assets/stickers/general/raised-hand.gif`, import.meta.url).href,
  scissors: new URL(`/src/assets/stickers/general/victory-hand.gif`, import.meta.url).href,
}
</script>

<template>
  <TheBottomSheet
    :show="show"
    @hide="hide"
  >
    <div class="w-full flex flex-col items-center">
      <div class="max-w-[214px] text-center text-base font-medium text-white/60">
        <T
          key-name="rps_challenge.message"
          default-value="Challenge {friendFirstName} to rock paper scissors! Select 3 moves"
          :params="{ friendFirstName: friendFirstName }"
        />
      </div>
      <div>
        <img
          v-for="[move, image] in Object.entries(moves)"
          :key="move"
          class="inline-block mr-2 w-12"
          :src="image"
          alt="move"
          @click="addMove(move)"
        >
      </div>
      <div>
        Your moves

        <div>
          <img
            v-for="move in selectedMoves"
            :key="move"
            class="inline-block mr-4 w-12"
            :src="moves[move]"
          >
        </div>
      </div>
      <BaseButton
        class="w-full mt-8"
        @click="submit"
      >
        <T
          key-name="rps_challenge.submit"
          default-value="Send"
        />
      </BaseButton>
    </div>
  </TheBottomSheet>
</template>

<style scoped>

</style>
